import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Send } from "lucide-react";

export function ChatThread({ messages, mine, onSend, placeholder = "Write a message…" }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: "end" });
  }, [messages.length]);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    const ok = await onSend(text.trim());
    if (ok) setText("");
    setBusy(false);
  };

  return (
    <div className="flex flex-col h-full min-h-0">
      <div data-testid="dm-message-list" className="flex-1 overflow-y-auto px-4 sm:px-6 py-6 space-y-3" data-lenis-prevent>
        {messages.length === 0 && <p className="text-sm text-[#4A5878] text-center py-10">No messages yet. Say hello.</p>}
        {messages.map((m) => {
          const self = m.sender === mine;
          return (
            <div key={m.id} data-testid="dm-message" className={`flex ${self ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[80%] px-4 py-3 text-sm leading-relaxed ${self ? "bg-[#D7263D] text-[#FFF8EE]" : "bg-[#E6F3FC] text-[#0E1B3D] border border-[#0E1B3D]/[0.08]"}`}>
                <p className="whitespace-pre-line">{m.text}</p>
                <p className={`mt-1 text-[0.65rem] ${self ? "text-[#FFF8EE]/70" : "text-[#4A5878]"}`}>{m.created_at ? format(new Date(m.created_at), "MMM d, HH:mm") : ""}</p>
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <form onSubmit={submit} className="border-t border-[#0E1B3D]/[0.08] p-3 sm:p-4 flex gap-3">
        <input data-testid="dm-chat-input" value={text} maxLength={2000} onChange={(e) => setText(e.target.value)} placeholder={placeholder}
          className="flex-1 bg-[#FFF8EE] border border-[#0E1B3D]/15 focus:border-[#D7263D] outline-none px-4 py-3 text-sm text-[#0E1B3D] placeholder:text-[#6B7894]" />
        <button data-testid="dm-send-btn" disabled={busy} className="gold-btn px-5 flex items-center gap-2 text-sm font-semibold disabled:opacity-60" aria-label="Send"><Send className="w-4 h-4" /></button>
      </form>
    </div>
  );
}
